<template>
  <v-btn
    rounded
    class="sign-in-button sn-btn"
    height="40"
    :color="translucentButtonColor"
    @click="handleClick"
  >
    <v-icon
      left
    >
      sn-icon-person
    </v-icon>
    Sign In
  </v-btn>
</template>

<script>
import { rgbaFromHexAndOpacity } from '~/assets/javascript/utilityFunctions.js'

export default {
  computed: {
    translucentButtonColor () {
      return this.rgbaFromHexAndOpacity(
        this.$vuetify.theme.themes.dark.tertiary,
        0.7
      )
    }
  },
  methods: {
    handleClick () {
      window.location.href = '/login'
    },
    rgbaFromHexAndOpacity
  }
}
</script>

<style scoped lang="scss">
  @import '~/assets/css/snui';

  .sign-in-button {
    text-transform: none;
    color: $sn-white !important;
  }
</style>
